/**
 * COMMENT ON THESE POSTS (Taylor, 2026-11-03) — "one of the most evergreen ones for me
 * will be leaving a comment on a target post". An admin lists the posts; the bounty counts
 * how many DIFFERENT listed posts a member has commented on since it went live, and opens
 * the next one she has not. A post she wrote herself is not one she can earn on, so it is
 * skipped. Which posts earned the points is reported per post.
 *
 * The list lives on the bounty (`config.postIds`), so the step means nothing in a quest.
 */

export const TARGET_POSTS_STEP_CODE = 'commentOnPosts';

/** The most posts one bounty may list. */
export const MAX_TARGET_POSTS = 50;

export type PostRef = { id: string } | { slug: string };

/**
 * What one pasted line names: a post id, a post slug, or a post link
 * (`…/community/<community>/post/<slug-or-id>` or `…/post/<slug-or-id>`). Null for a
 * blank line or anything that is not one.
 */
export function parsePostRef(line: string): PostRef | null {
  const text = line.trim();
  if (!text) return null;
  const fromPath = text.match(/\/post\/([^/?#\s]+)/);
  const key = fromPath ? fromPath[1]! : text;
  if (/^\d{1,18}$/.test(key)) return { id: key };
  if (/^[a-z0-9][a-z0-9-]*$/i.test(key) && !text.includes('://')) return { slug: key };
  if (fromPath && /^[a-z0-9][a-z0-9-]*$/i.test(key)) return { slug: key };
  return null;
}
